export default "__VITE_PUBLIC_ASSET__13825283__"